(() => {
    if (window.ChatEscolhaShopifyLoaded) {
        return;
    }

    window.ChatEscolhaShopifyLoaded = true;

    const defaults = {
        endpoint: '',
        hostId: 'chatescolha-shopify-root',
        title: 'ChatEscolha',
        subtitle: 'Assistente online',
        brandMark: 'C',
        welcomePrimary: 'Ola!',
        welcomeSecondary: 'Como podemos ajudar hoje?',
        placeholder: 'Escreva a sua mensagem',
        openByDefault: false,
        zIndex: 99999,
        quickActions: [
            'Quais as marcas de aparelhos auditivos fornecidas?',
            'Quais sao as opcoes de pagamento disponiveis?',
            'Como funciona a politica de devolucao?'
        ]
    };

    const config = Object.assign({}, defaults, window.ChatEscolhaShopifyConfig || {});

    if (!config.endpoint) {
        console.warn('ChatEscolha Shopify: falta definir o endpoint do chat.');
        return;
    }

    const styles = `
        :host {
            all: initial;
        }

        *, *::before, *::after {
            box-sizing: border-box;
        }

        .ce-shell {
            position: fixed;
            right: 20px;
            bottom: 20px;
            z-index: ${String(config.zIndex)};
            font-family: "Segoe UI Variable", "Segoe UI", "Helvetica Neue", Arial, sans-serif;
            color: #0f1728;
        }

        .ce-widget {
            width: min(400px, calc(100vw - 24px));
            max-height: min(720px, calc(100vh - 24px));
            display: none;
            flex-direction: column;
            border-radius: 24px;
            background: #ffffff;
            border: 1px solid rgba(9, 30, 66, 0.1);
            box-shadow: 0 24px 90px rgba(7, 20, 48, 0.18);
            overflow: hidden;
        }

        .ce-shell.is-open .ce-widget {
            display: flex;
        }

        .ce-shell.is-open .ce-launcher {
            opacity: 0;
            pointer-events: none;
            transform: scale(0.88);
        }

        .ce-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 16px;
            padding: 16px 16px 14px;
            border-bottom: 1px solid rgba(9, 30, 66, 0.1);
            background: linear-gradient(180deg, #ffffff 0%, #fafcff 100%);
        }

        .ce-brand {
            display: flex;
            align-items: center;
            gap: 12px;
            min-width: 0;
        }

        .ce-brand-mark {
            width: 40px;
            height: 40px;
            border-radius: 14px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(180deg, #204444 0%, #365656 100%);
            color: #ffffff;
            font-size: 1rem;
            font-weight: 800;
            letter-spacing: -0.04em;
            flex: 0 0 auto;
        }

        .ce-brand-copy {
            display: grid;
            gap: 2px;
            min-width: 0;
        }

        .ce-brand-copy strong {
            font-size: 14px;
            letter-spacing: -0.02em;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .ce-brand-copy span {
            color: #60708f;
            font-size: 12px;
        }

        .ce-close,
        .ce-send,
        .ce-launcher,
        .ce-quick-action {
            font: inherit;
        }

        .ce-launcher-icon {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            display: block;
            object-fit: contain;
            pointer-events: none;
        }

        .ce-close {
            width: 38px;
            height: 38px;
            border: 0;
            border-radius: 12px;
            background: transparent;
            color: #60708f;
            font-size: 1.55rem;
            line-height: 1;
            cursor: pointer;
            flex: 0 0 auto;
        }

        .ce-body {
            flex: 1;
            min-height: 0;
            padding: 18px 16px;
            background: linear-gradient(180deg, #ffffff 0%, #fbfcff 100%);
            overflow-y: auto;
        }

        .ce-welcome {
            display: grid;
            gap: 10px;
        }

        .ce-shell.has-conversation .ce-welcome {
            display: none;
        }

        .ce-bubble {
            max-width: 82%;
            padding: 13px 15px;
            border-radius: 18px;
            background: #edf3fb;
            color: #0f1728;
            box-shadow: inset 0 0 0 1px rgba(15, 23, 40, 0.04);
            font-size: 14px;
            line-height: 1.68;
            white-space: pre-wrap;
        }

        .ce-bubble.is-muted {
            max-width: 70%;
        }

        .ce-quick-actions {
            display: grid;
            gap: 10px;
            padding-top: 40px;
        }

        .ce-quick-action {
            min-height: 46px;
            padding: 10px 16px;
            border-radius: 16px;
            border: 1px solid rgb(212, 214, 203);
            background: #ffffff;
            color: #204444;
            font-weight: 600;
            font-size: 14px;
            cursor: pointer;
            text-align: left;
            width: fit-content;
            margin-left: auto;
        }

        .ce-quick-action:hover {
            background: #eaf2ff;
        }

        .ce-messages {
            display: none;
            gap: 18px;
        }

        .ce-shell.has-conversation .ce-messages {
            display: grid;
        }

        .ce-message {
            width: 100%;
        }

        .ce-message-row {
            display: flex;
        }

        .ce-message-user .ce-message-row {
            justify-content: flex-end;
        }

        .ce-message-text {
            display: block;
            max-width: 92%;
            padding: 12px 14px;
            border-radius: 18px;
            font-size: 14px;
            line-height: 1.68;
            white-space: pre-wrap;
            word-break: break-word;
        }

        .ce-message-user .ce-message-text {
            max-width: 86%;
            border-radius: 18px 18px 6px 18px;
            background: #0f6fff;
            color: #ffffff;
        }

        .ce-message-assistant .ce-message-text {
            border-radius: 18px 18px 18px 6px;
            background: #edf3fb;
            color: #0f1728;
            box-shadow: inset 0 0 0 1px rgba(15, 23, 40, 0.04);
        }

        .ce-message-error .ce-message-text {
            border-radius: 18px;
            background: #fff1ef;
            color: #9f2b1d;
            border: 1px solid rgba(204, 72, 49, 0.2);
        }

        .ce-composer {
            padding: 14px 16px 16px;
            border-top: 1px solid rgba(9, 30, 66, 0.1);
            background: #ffffff;
        }

        .ce-composer-shell {
            display: flex;
            align-items: flex-end;
            gap: 10px;
            min-height: 58px;
            padding: 10px 10px 10px 14px;
            border-radius: 18px;
            background: #f3f6fb;
            border: 1px solid rgba(15, 23, 40, 0.06);
        }

        .ce-input {
            width: 100%;
            min-height: 37px;
            max-height: 180px;
            border: 0;
            background: transparent;
            color: #0f1728;
            font: inherit;
            font-size: 14px;
            line-height: 1.8;
            resize: none;
            overflow-y: auto;
            padding: 4px 0;
            outline: none;
        }

        .ce-input::placeholder {
            color: #60708f;
        }

        .ce-send {
            width: 40px;
            height: 40px;
            border: 0;
            border-radius: 999px;
            flex: 0 0 auto;
            background: #204444;
            color: #ffffff;
            font-size: 1.1rem;
            font-weight: 700;
            cursor: pointer;
            transition: transform 140ms ease, opacity 140ms ease, background 140ms ease;
        }

        .ce-send:hover {
            transform: translateY(-1px);
            background: #204444;
        }

        .ce-send:disabled,
        .ce-input:disabled {
            opacity: 0.55;
            cursor: wait;
        }

        .ce-launcher {
            position: absolute;
            right: 20px;
            bottom: 20px;
            width: 86px;
            height: 86px;
            border: 0;
            border-radius: 999px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(180deg, #204444 0%, #204444 100%);
            color: #ffffff;
            cursor: pointer;
            box-shadow: 0 18px 40px rgb(212, 214, 203);
            transition: transform 180ms ease, opacity 180ms ease;
        }

        .ce-launcher-ring {
            position: absolute;
            inset: 6px;
            border-radius: 999px;
            border: 1px solid rgba(255, 255, 255, 0.22);
        }

        .ce-launcher-label {
            position: relative;
            font-size: 1.28rem;
            line-height: 1;
        }

        .ce-visually-hidden {
            position: absolute;
            width: 1px;
            height: 1px;
            padding: 0;
            margin: -1px;
            overflow: hidden;
            clip: rect(0, 0, 0, 0);
            white-space: nowrap;
            border: 0;
        }

        @media (max-width: 560px) {
            .ce-shell {
                right: 12px;
                bottom: 12px;
            }

            .ce-widget {
                width: calc(100vw - 24px);
                max-height: calc(100vh - 24px);
            }

            .ce-launcher {
                width: 70px;
                height: 70px;
            }
        }
    `;

    const template = `
        <div class="ce-shell">
            <section class="ce-widget" aria-hidden="true">
                <header class="ce-header">
                    <div class="ce-brand">
                        <span class="ce-brand-mark"></span>
                        <div class="ce-brand-copy">
                            <strong></strong>
                            <span></span>
                        </div>
                    </div>
                    <button type="button" class="ce-close" aria-label="Fechar chat">&times;</button>
                </header>

                <div class="ce-body">
                    <div class="ce-welcome">
                        <article class="ce-bubble ce-welcome-primary"></article>
                        <article class="ce-bubble ce-bubble is-muted ce-welcome-secondary"></article>
                        <div class="ce-quick-actions"></div>
                    </div>
                    <div class="ce-messages" aria-live="polite"></div>
                </div>

                <form class="ce-composer" novalidate>
                    <label class="ce-visually-hidden" for="ce-message">Mensagem</label>
                    <div class="ce-composer-shell">
                        <textarea id="ce-message" class="ce-input" rows="1" maxlength="2000" required></textarea>
                        <button type="submit" class="ce-send" aria-label="Enviar mensagem">&#8593;</button>
                    </div>
                </form>
            </section>

            <button type="button" class="ce-launcher" aria-label="Abrir chat" aria-expanded="false">
                <span class="ce-launcher-ring"></span>
                <span class="ce-launcher-label">
                    <img
                        src="https://cdn.shopify.com/s/files/1/1042/4126/7020/files/virtual_assistance.jpg?v=1785151931"
                        alt="Assistente Virtual"
                        class="ce-launcher-icon"
                    >
                </span>
            </button>
        </div>
    `;

    function mountWidget() {
        let host = document.getElementById(config.hostId);

        if (!host) {
            host = document.createElement('div');
            host.id = config.hostId;
            document.body.appendChild(host);
        }

        if (host.shadowRoot) {
            return;
        }

        const shadow = host.attachShadow({ mode: 'open' });
        shadow.innerHTML = `<style>${styles}</style>${template}`;

        const shell = shadow.querySelector('.ce-shell');
        const widget = shadow.querySelector('.ce-widget');
        const launcher = shadow.querySelector('.ce-launcher');
        const closeButton = shadow.querySelector('.ce-close');
        const form = shadow.querySelector('.ce-composer');
        const input = shadow.querySelector('.ce-input');
        const sendButton = shadow.querySelector('.ce-send');
        const messagesNode = shadow.querySelector('.ce-messages');
        const quickActionsNode = shadow.querySelector('.ce-quick-actions');
        const primaryWelcome = shadow.querySelector('.ce-welcome-primary');
        const secondaryWelcome = shadow.querySelector('.ce-welcome-secondary');
        const brandMark = shadow.querySelector('.ce-brand-mark');
        const brandTitle = shadow.querySelector('.ce-brand-copy strong');
        const brandSubtitle = shadow.querySelector('.ce-brand-copy span');

        brandMark.textContent = config.brandMark;
        brandTitle.textContent = config.title;
        brandSubtitle.textContent = config.subtitle;
        primaryWelcome.textContent = config.welcomePrimary;
        secondaryWelcome.textContent = config.welcomeSecondary;
        input.placeholder = config.placeholder;

        const setOpen = (isOpen) => {
            shell.classList.toggle('is-open', isOpen);
            widget.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
            launcher.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

            if (isOpen) {
                window.setTimeout(() => input.focus(), 80);
            }
        };

        const setConversationState = (hasConversation) => {
            shell.classList.toggle('has-conversation', hasConversation);
        };

        const resizeInput = () => {
            input.style.height = '0px';
            input.style.height = `${Math.min(input.scrollHeight, 240)}px`;
        };

        const setBusy = (busy) => {
            input.disabled = busy;
            sendButton.disabled = busy;
        };

        const appendMessage = (role, text) => {
            const article = document.createElement('article');
            article.className = `ce-message ce-message-${role}`;

            const row = document.createElement('div');
            row.className = 'ce-message-row';

            const body = document.createElement('div');
            body.className = 'ce-message-text';

            const urlRegex = /(https?:\/\/[^\s]+)/g;
            const parts = String(text).split(urlRegex);

            parts.forEach((part) => {
                if (/^https?:\/\//i.test(part)) {
                    const link = document.createElement('a');

                    link.href = part;
                    link.textContent = part;
                    link.target = '_blank';
                    link.rel = 'noopener noreferrer';

                    body.appendChild(link);
                } else {
                    body.appendChild(document.createTextNode(part));
                }
            });

            row.appendChild(body);
            article.appendChild(row);
            messagesNode.appendChild(article);
            messagesNode.scrollTop = messagesNode.scrollHeight;
            setConversationState(true);
            setOpen(true);
        };

        const postMessage = async (message) => {
            const response = await fetch(config.endpoint, {
                method: 'POST',
                mode: 'cors',
                credentials: 'omit',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    message
                })
            });

            const payload = await response.json().catch(() => ({}));

            if (!response.ok) {
                throw new Error(payload.error || 'Nao foi possivel obter resposta do assistente.');
            }

            return payload;
        };

        const submitMessage = async (message) => {
            appendMessage('user', message);
            input.value = '';
            resizeInput();
            setBusy(true);

            try {
                const payload = await postMessage(message);
                appendMessage('assistant', typeof payload.answer === 'string' ? payload.answer : 'Sem resposta devolvida pela API.');
            } catch (error) {
                appendMessage('error', error instanceof Error ? error.message : 'Erro inesperado.');
            } finally {
                setBusy(false);
                input.focus();
            }
        };

        const quickActions = Array.isArray(config.quickActions) ? config.quickActions : [];

        quickActions.forEach((label) => {
            if (typeof label !== 'string' || label.trim() === '') {
                return;
            }

            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'ce-quick-action';
            button.textContent = label;
            button.addEventListener('click', () => {
                submitMessage(label.trim());
            });
            quickActionsNode.appendChild(button);
        });

        launcher.addEventListener('click', () => {
            setOpen(!shell.classList.contains('is-open'));
        });

        closeButton.addEventListener('click', () => {
            setOpen(false);
        });

        input.addEventListener('input', () => {
            resizeInput();
        });

        input.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' && !event.shiftKey) {
                event.preventDefault();
                form.requestSubmit();
            }
        });

        form.addEventListener('submit', (event) => {
            event.preventDefault();
            const message = input.value.trim();

            if (!message) {
                return;
            }

            submitMessage(message);
        });

        resizeInput();
        setConversationState(false);
        setOpen(Boolean(config.openByDefault));

        // Abrir automaticamente após 10 segundos apenas na homepage
        if (window.location.pathname === '/' && !config.openByDefault) {
            let userInteracted = false;

            launcher.addEventListener('click', () => {
                userInteracted = true;
            });

            closeButton.addEventListener('click', () => {
                userInteracted = true;
            });

            window.setTimeout(() => {
                if (!userInteracted && !shell.classList.contains('is-open')) {
                    setOpen(true);
                }
            }, 10000);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', mountWidget, { once: true });
    } else {
        mountWidget();
    }
})();
